{{data.name}}
<!--Vista 1 - Datos de remitente-->
<div *ngIf="showSecondView===1">

  <h2>Nueva SR - Datos Remitente</h2>
  <div class="input-group mb-3" *ngIf="cliente.id">
    <span class="input-group-text" id="inputGroup-sizing-default">Mis direcciones</span>
    <select class="form-select" aria-label="Select Vehiculo" (ngModelChange)="onchange($event)" [(ngModel)]="direccionActiva">
      <!-- <option *ngFor="let m of direcciones" value={{m.id}} >{{m.nombre}}: {{m.localidad}}, {{m.direccion}} ({{m.cp}}) {{m.piso_dpto}}</option> -->
      <option *ngFor="let m of direcciones" [ngValue]="m" >{{m.nombre}}: {{m.localidad}}, {{m.direccion}} ({{m.cp}}) {{m.piso_dpto}}</option>
    </select>
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">DNI</span>
    <input id="dni" [(ngModel)]="sr.dni" type="number" class="form-control" (focusout)="completarRemitente()"
      aria-label="dni" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text">Nombres y Apellidos</span>
    <input id="origen_nombre" [(ngModel)]="sr.origen_nombre" type="text" aria-label="Nombre" class="form-control">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">E-Mail</span>
    <input id="email" [(ngModel)]="sr.email" type="text" class="form-control" aria-label="Email"
      aria-describedby="inputGroup-sizing-default" placeholder="ejemplo@ejemplo.com">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Telefono</span>
    <input id="telefono" [(ngModel)]="sr.telefono" type="number" class="form-control" aria-label="Telefono"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Provincia</span>
    <input id="origen_provincia" [(ngModel)]="sr.origen_provincia" type="text" class="form-control"
      aria-label="origenProvincia" aria-describedby="inputGroup-sizing-default">
    <span class="input-group-text" id="inputGroup-sizing-default">Localidad</span>
    <input id="origen_localidad" [(ngModel)]="sr.origen_localidad" type="text" class="form-control"
      aria-label="origenLocalidad" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Direccion</span>
    <input id="origen_direccion" [(ngModel)]="sr.origen_direccion" type="text" class="form-control"
      aria-label="origenDireccion" aria-describedby="inputGroup-sizing-default">

  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Codigo Postal</span>
    <input id="origen_cp" [(ngModel)]="sr.origen_cp" type="number" class="form-control" aria-label="origenCp"
      aria-describedby="inputGroup-sizing-default">
    <span class="input-group-text" id="inputGroup-sizing-default">Piso departamento</span>
    <input id="origen_piso_departamento" [(ngModel)]="sr.origen_piso_departamento" type="text" class="form-control"
      aria-label="origen_piso_departamento" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="form-check form-check-inline" *ngIf="sr.id_franja_horaria===1">
    <span class="input-group-text mb-1" id="inputGroup-sizing-default">Franja Horaria</span>
    <input type="radio" class="btn-check" name="options-outlined" id="success-outlined" autocomplete="off" checked>
    <label class="btn btn-outline-primary" for="success-outlined" (click)="franjaHoraria(1)">8:00-14:00</label>
    <input type="radio" class="btn-check" name="options-outlined" id="danger-outlined" autocomplete="off">
    <label class="btn btn-outline-primary" for="danger-outlined" (click)="franjaHoraria(2)">14:00-19:00</label>
  </div>

  <div class="form-check form-check-inline" *ngIf="sr.id_franja_horaria===2">
    <span class="input-group-text mb-1" id="inputGroup-sizing-default">Franja Horaria</span>
    <input type="radio" class="btn-check" name="options-outlined" id="success-outlined" autocomplete="off">
    <label class="btn btn-outline-primary" for="success-outlined" (click)="franjaHoraria(1)">8:00-14:00</label>
    <input type="radio" class="btn-check" name="options-outlined" id="danger-outlined" autocomplete="off" checked>
    <label class="btn btn-outline-primary" for="danger-outlined" (click)="franjaHoraria(2)">14:00-19:00</label>
  </div>

  <div class="form-floating text-center justify-content-md-end mb-1">
    <button class="btn btn-primary" type="button" (click)="changeView(2)">Continuar</button>
  </div>

</div>

<!--Vista 2 - Datos de destinatario-->
<div *ngIf="showSecondView===2">

  <h2>Nueva SR - Datos Destinatario</h2>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">DNI</span>
    <input id="destino_cuit" [(ngModel)]="sr.destino_cuit" type="number" class="form-control"
      (focusout)="completarRemitente()" aria-label="destinoDni" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text">Nombre y Apellido</span>
    <input id="destino_nombre" [(ngModel)]="sr.destino_nombre" type="text" aria-label="destinoNombre"
      class="form-control">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">E-Mail</span>
    <input id="destino_email" [(ngModel)]="sr.destino_email" type="text" class="form-control" aria-label="destinoEmail"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Telefono</span>
    <input id="destino_telefono" [(ngModel)]="sr.destino_telefono" type="number" class="form-control"
      aria-label="destinoTelefono" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Provincia</span>
    <input id="destino_provincia" [(ngModel)]="sr.destino_provincia" type="text" class="form-control"
      aria-label="destinoProvincia" aria-describedby="inputGroup-sizing-default">
    <span class="input-group-text" id="inputGroup-sizing-default">Localidad</span>
    <input id="destino_localidad" [(ngModel)]="sr.destino_localidad" type="text" class="form-control"
      aria-label="destinoLocalidad" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Direccion</span>
    <input id="destino_direccion" [(ngModel)]="sr.destino_direccion" type="text" class="form-control"
      aria-label="destinoDireccion" aria-describedby="inputGroup-sizing-default">
    <span class="input-group-text" id="inputGroup-sizing-default">Entre Calles</span>
    <input id="destino_entrecalles" [(ngModel)]="sr.destino_entrecalles" type="text" class="form-control"
        aria-label="destino_entrecalles" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Codigo Postal</span>
    <input id="destino_cp" [(ngModel)]="sr.destino_cp" type="number" class="form-control" aria-label="destinoCp"
      aria-describedby="inputGroup-sizing-default">
    <span class="input-group-text" id="inputGroup-sizing-default">Piso departamento</span>
    <input id="destino_piso_departamento" [(ngModel)]="sr.destino_piso_departamento" type="text" class="form-control"
      aria-label="origen_piso_departamento" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="form-floating text-center justify-content-md-end mb-1">
    <button class="btn btn-primary" type="button" (click)="changeView(1)">Volver</button>
    <button class="btn btn-primary" type="button" (click)="changeView(3)">Continuar</button>
  </div>

</div>

<!--Vista 2 - Datos de destinatario-->
<div *ngIf="showSecondView===3">

  <h2>Nueva SR - Datos de Paqueteria</h2>
  <div *ngIf="alertadetalle===true" class="alert alert-danger" role="alert">
    No puede enviar una solicitud sin detalle
  </div>
  <table class="table table-hover table-sm table-responsive">
    <thead class="table-dark">
      <tr>
        <th scope="col">Nro</th>
        <th scope="col">Peso</th>
        <th scope="col">Valor Declarado</th>
        <th scope="col">Observacion</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody class="table-light">
      <tr *ngFor="let m of listSrD">
        <th *ngIf="m.estado===1">{{m.id_bulto}}</th>
        <td *ngIf="m.estado===1">{{m.peso}}</td>
        <td *ngIf="m.estado===1">{{m.valor_declarado}}</td>
        <td *ngIf="m.estado===1">{{m.observacion}}</td>
        <td *ngIf="m.estado===1">
          <button type="button" class="btn btn-danger btn-sm" (click)="quitarDetalle(m.id_bulto)">Quitar</button>
        </td>
        <th *ngIf="m.estado===0" class="table-danger">{{m.id_bulto}}</th>
        <td *ngIf="m.estado===0" class="table-danger">{{m.peso}}</td>
        <td *ngIf="m.estado===0" class="table-danger">{{m.valor_declarado}}</td>
        <td *ngIf="m.estado===0" class="table-danger">{{m.observacion}}</td>
        <td *ngIf="m.estado===0" class="table-danger">
          <button type="button" class="btn btn-danger btn-sm" (click)="quitarDetalle(m.id_bulto)">Quitar</button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Peso en gramos</span>
    <input id="peso" [(ngModel)]="srD.peso" placeholder="peso" type="number" class="form-control"
      aria-label="destinoDireccion" aria-describedby="inputGroup-sizing-default">
    <span class="input-group-text" id="inputGroup-sizing-default">Valor Monetario (en pesos)</span>
    <input id="valor_declarado" [(ngModel)]="srD.valor_declarado" placeholder="valor_declarado" type="number"
      class="form-control" aria-label="destinoAltura" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <label for="exampleFormControlTextarea1" class="input-group-text">Observacion</label>
    <textarea id="observacion" [(ngModel)]="srD.observacion" class="form-control" rows="2"></textarea>
  </div>

  <button class="btn btn-primary" type="button" (click)="agregarDetalle()">Agregar</button>
<br><br>
  <div>
    <h2>Contrareembolso</h2>
  </div>
  <div class="form-check">
    <input class="form-check-input" type="checkbox" value="" id="is_contrareembolso" [(ngModel)]="sr.is_contrareembolso">
    <label class="form-check-label" for="is_contrareembolso">
      Habilitar contrareembolso
    </label>
  </div>
  <div class="input-group mb-3" *ngIf="sr.is_contrareembolso">
    <span class="input-group-text" id="inputGroup-sizing-default">Valor Monetario</span>
    <input id="contrareembolso" [(ngModel)]="sr.contrareembolso_valor" placeholder="contrareembolso" type="number" class="form-control"
      aria-label="Valor Monetario" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="form-floating text-center justify-content-md-end mb-1">
    <button class="btn btn-primary" type="button" (click)="changeView(2)">Volver</button>
    <button class="btn btn-primary" type="button" (click)="changeView(3)" disabled>Continuar</button>
  </div>
</div>

<div class="form-floating text-center justify-content-md-end">
  <button *ngIf="sr.id!==undefined" class="btn btn-primary" type="button" (click)="crearpdf()" >Imprimir</button>
  <button *ngIf="showSecondView!==3" class="btn btn-primary" type="button"  [mat-dialog-close]="id" disabled>Enviar</button>
  <button *ngIf="showSecondView===3" class="btn btn-primary" type="button" (click)="enviar()" >Enviar</button>
</div>
